import React, { useEffect, useState } from 'react';
import API from '../../../Utils/api';
import { useUser } from '../../../Context/useUser';
import { useParams } from 'react-router';
import { useVisitingUser } from '../../../Hooks/useVisitingUser';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const ZONES_DISPLAY = {
    rec: 'Over Distance (Rec)',
    end1: 'Basic Aerobic (End1)',
    end2: 'Lactate Threshold (End2)',
    end3: 'VO2 Max (End3)',
    sp1: 'Lactate Tolerance (SP1)',
    sp2: 'Produce Lactate (SP2)',
    sp3: 'Max Speed & Power (SP3)'
};

const COLORS = ['#F87171', '#FBBF24', '#34D399', '#60A5FA', '#A78BFA', '#F472B6', '#D1D5DB'];

export default function TrainingZonesChart() {
    const { user } = useUser();
    const { athleteId } = useParams();
    const visitedUser = useVisitingUser(athleteId);
    const currentUser = athleteId ? visitedUser : user;
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser) return;
        setLoading(true);
        API.getTrainingZonesStats(currentUser._id)
            .then(({ data }) => setStats(data))
            .finally(() => setLoading(false));
    }, [currentUser]);

    const chartData = {
        labels: stats.map(s => ZONES_DISPLAY[s.zone]),
        datasets: [
            {
                label: 'Distance (m)',
                data: stats.map(s => s.distance),
                backgroundColor: COLORS,
                borderRadius: 12,
                barPercentage: 0.7,
                categoryPercentage: 0.7,
                borderSkipped: false
            }
        ]
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        plugins: {
            legend: { display: false },
            datalabels: {
                color: '#fff',
                anchor: 'center',
                align: 'center',
                font: { weight: 'bold', size: 16 },
                formatter: (value, context) => `${stats[context.dataIndex]?.percentage ?? 0} %`,
                display: context => context.dataset.data[context.dataIndex] > 0
            },
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function (context) {
                        const stat = stats[context.dataIndex];
                        return `${ZONES_DISPLAY[stat.zone]}: ${stat.distance}m (${
                            stat.percentage
                        }%)`;
                    }
                }
            },
            title: { display: false }
        },
        scales: {
            x: {
                beginAtZero: true,
                grid: { color: '#ccc' },
                title: { display: true, text: 'Distance (m)' }
            },
            y: {
                grid: { color: '#ccc' }
            }
        }
    };

    return (
        <div style={{ position: 'relative', borderRadius: 16 }}>
            <h4 style={{ marginBottom: 10 }}>Training Zones</h4>
            {loading ? (
                <div>Loading...</div>
            ) : stats.length === 0 ? (
                <div>No data found.</div>
            ) : (
                <div style={{ position: 'relative' }}>
                    <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
                </div>
            )}
        </div>
    );
}
